import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBdncVzunmVfxiA4D1OhAvFyPV14aEn9po",
  authDomain: "simplekindnes.firebaseapp.com",
  projectId: "simplekindnes",
  storageBucket: "simplekindnes.firebasestorage.app",
  messagingSenderId: "57144453954",
  appId: "1:57144453954:web:e8393f440b55166298f6db",
  measurementId: "G-2DR4CZ3M46"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, { localCache: memoryLocalCache() });
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export default app;
